// ── Section Scénarios ───────────────────────────────────────────────────────
// Un scénario nommé regroupe des hypothèses projetées qui traversent tous les
// modules (revenus, contrats, mesures, loyers, charges, salaires).

export interface ScenarioDetaille {
  id: number;
  nom: string;
  description: string | null;
  archive: boolean;
  cree_le: string;
  // Héritage : un scénario enfant lit les projections de sa chaîne de parents
  // en plus des siennes. Les décomptes ci-dessous ne comptent que ses
  // projections **propres** — ses surcharges.
  parent_id: number | null;
  parent_nom: string | null;
  socle: boolean;
  auteur: string | null;
  nb_evenements: number;
  parModule: Record<string, number>;
}

export interface ProjectionScenario {
  module: string;
  table: string;
  id: number;
  ligne: string;
  datation: string;      // mois d'effet (ou 1er janvier pour un terme annuel)
  valeur: number | null; // null quand la valeur n'est pas un scalaire (répartition)
  unite: string;
  commentaire: string;
  auteur: string | null;
  cree_le: string;
}

/** Ancre de navigation vers le module qui porte la projection. */
export const PAGE_PAR_MODULE: Record<string, string> = {
  Revenus: 'revenus',
  Contrats: 'contrats',
  Mesures: 'mesures',
  Loyers: 'loyers',
  Charges: 'charges',
  Salaires: 'salaires',
};
